import { injectBaseConstantMethods } from "./BaseConstants";

export const AUDIO_STATUS = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE"
};

const displayTextKeys = {
    [AUDIO_STATUS.ACTIVE]: "Active",
    [AUDIO_STATUS.INACTIVE]: "Inactive"
};

const labelClass = {
    [AUDIO_STATUS.ACTIVE]: "cs-badge-active",
    [AUDIO_STATUS.INACTIVE]: "cs-badge-inactive"
};

export default injectBaseConstantMethods(AUDIO_STATUS, displayTextKeys, labelClass);
